import Axios from "axios";
import {
  SET_INV_LC_RECEIVE_REPORT,
  UNSET_INV_LC_RECEIVE_REPORT,
} from "@/store/mutation-types";
import { getInvLcReceiveReport } from "@/store/api";

const state = {
  getInvLcReceiveReport: {},
};

const getters = {
  getInvLcReceiveReport(state) {
    return state.getInvLcReceiveReport;
  },
};

const mutations = {
  [SET_INV_LC_RECEIVE_REPORT](state, data) {
    state.getInvLcReceiveReport = data;
  },
  [UNSET_INV_LC_RECEIVE_REPORT](state) {
    state.getInvLcReceiveReport = {};
  },
};

const actions = {
  getInvLcReceiveReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvLcReceiveReport, { params })
        .then(function (response) {
          commit("SET_INV_LC_RECEIVE_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_LC_RECEIVE_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
